import axios from "@/plugins/axios";

let url = "/api/v1/shop/exhibitions";

export default {
    getExhibitions(data){
        return axios.get(url, data).then(result => result.data);
    }
}
